// src/components/ClientsOnlineDashboard/components/LoadingSpinner.tsx

import React from "react";
import "../styles/LoadingSpinner.css";

const LoadingSpinner: React.FC = () => {
  return (
    <div className="loading-spinner-container">
      <div className="spinner" />
      <span className="loading-text">Chargement des données...</span>
    </div>
  );
};

export default LoadingSpinner;